module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1041-1d5fcdd65a21d782600b90ac381634b7.png";